import moment from "moment"
import {
  CheckBox,
  FormRow,
  Input,
  Label,
  SelectInput,
  SelectInputCreatable,
  TextArea,
} from "../../components/Form"
import { IoOpenOutline } from "react-icons/io5";
import { Grid } from "../../components/Table"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../../components/Modal"
import { HeaderCard } from "../../components/Header"
import { Button, ButtonLoader } from "../../components/Button"
import { TagsCellGrid } from "../../components/UserList"
import { LoadingWithLabel } from "../../components/Loading"
import { getInputType } from "../../components/GetInputType";
import { AssistanceTagContainer } from "../../container/AssistanceTagContainer";
import "./styles.scss";
import ModalAlert from "../../components/ModalAlert";

export const ModalSelectQuestions = ({
  modalIsOpen,
  formSteps,
  onChange,
  onCloseModal,
  value,
  showQuestions,
  selectedDescription,
}) => {
  return (
    <ModalPanel modalIsOpen={modalIsOpen}>
      <ModalHeader closeModal={onCloseModal} title="Etapa do Atendimento" />
      <ModalBody>
        <div className="scroll-select-modal question-options-modal">
          <FormRow>
            <Label label="Selecione a etapa do atendimento" />
            <SelectInput
              isSearchable
              onChange={onChange}
              options={formSteps.map((item) => ({
                value: item.value,
                label: item.label,
              }))}
              placeholder="Selecione uma etapa"
              isOverModal={true}
            />
          </FormRow>
          <h5 style={{ marginTop: "16px" }}>Observações:</h5>
          <p>{selectedDescription}</p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          className="button-engagement"
          color="orange"
          handleClick={showQuestions}
          label={"Continuar"}
          isDisabled={!Object.keys(value).length}
        />
      </ModalFooter>
    </ModalPanel>
  )
}

const ProducersCell = ({ value, data }) => {
  if(!data?.producers) return <></>

  const newProducerList = data.producers.slice(0, 4);
  
  return <div className='producer-cell__container'>
    {newProducerList.map(userName => (
      <small>{userName}</small>
    ))}
    {value && data?.producers.length > 4 ? <p>+{data?.producers.length - newProducerList.length}</p> : <></>}
  </div>
}

export const GoToResolveQuestionsCell = ({ data, value, ...props }) => {
  const isDate = props?.column?.label === "Data de Inicio" ?
    moment(value).format("DD/MM/YYYY") : '';

  return (
    <div
      className="rgt-cell-inner"
      style={{ display: "flex", alignItems: "center", overflow: "hidden", cursor: "pointer" }}
    >
      {isDate || value}
    </div>
  )
}

export const AssistanceToResolveScreen = ({
  dataResolve,
  loadingDataToResolve,
  openQuestions,
  goBack,
  formSteps,
  evaluationModal,
  onChangeQuestionsInfo,
  setSelectedRow,
  saveFormSubmission,
  loading,
  afterResolveModal,
  handleOpenNextEvent,
  handleCloseNextEvent,
  nextDateValues,
  handleChangeNextDate,
  onChangeFile,
  uploadedFiles,
  removeFile,
  loadingProcessImage,
  formOptions,
  onStepSelect,
  selectedStep,
  control,
  register,
  values,
  handleChangeTags,
  loadingQuestions,
  tags,
  handleRemoveTag,
  pendingAssistance,
  handlePendingAssistance,
  handleSelectedAssistance,
  handleSearchTagChange,
  selectedAssistance,
  setReload,
  tagsOptions,
  searchTagValue,
  currentRowData,
  inputData,
  handleSendEvaluation
}) => {

  const commonCellRenderer = (props) => (
    <GoToResolveQuestionsCell {...props}/>
  )

  const columns = () => [
    {
      id: "checkbox",
      field: "checkbox",
    },
    {
      id: "toResolve",
      field: "ids",
      cellRenderer: ({ data }) => (
        <div
          className="rgt-cell-inner"
          style={{ width: '100%', textAlign: 'center', cursor: 'pointer' }}
          title={`Resolver ${data?.form}`}
          onClick={() => setSelectedRow(data?.id)}
        >
          <IoOpenOutline color="#008e00"/>
        </div>
      ),
      label: "Abrir",
      width: "100px",
    },
    {
      id: "eventTitle",
      field: "eventTitle",
      cellRenderer: ({ data }) => (
        <div className="rgt-cell-inner rgt-text-truncate" title={data?.eventTitle}>{data?.eventTitle}</div>
      ),
      label: "Título",
      width: "400px",
      cellRenderer: commonCellRenderer,
    },
    {
      id: "responsible",
      field: "responsible",
      cellRenderer: ({ data }) => (
        <div className="rgt-cell-inner rgt-text-truncate" title={data?.responsible}>{data?.responsible}</div>
      ),
      label: "Quem Criou",
      width: "300px",
      cellRenderer: commonCellRenderer,
    },
    {
      id: "technician",
      field: "technician",
      cellRenderer: ({ data }) => (
        <div className="rgt-cell-inner rgt-text-truncate" title={data?.technician}>{data?.technician}</div>
      ),
      label: "Técnico(a)",
      width: "300px",
      cellRenderer: commonCellRenderer,
    },
    {
      id: "project",
      field: "project",
      label: "Projeto",
      width: "300px",
      cellRenderer: commonCellRenderer,
    },
    {
      id: "assistance",
      field: "form",
      label: "Formulário",
      width: "300px",
      cellRenderer: commonCellRenderer,
    },
    {
      id: "user",
      field: "producers",
      label: "Produtores",
      width: "400px",
      cellRenderer: ({ value, data }) => <ProducersCell value={value} data={data} />,
    },
    {
      id: "tags",
      field: "tags",
      label: "Tags",
      width: "420px",
      cellRenderer: ({ data }) => <div className="tags-assistance">
        <TagsCellGrid {...{ data }} handleRemoveTag={handleRemoveTag} />
      </div>,
    },
    {
      id: "description",
      field: "description",
      cellRenderer: ({ data }) => (
        <div className="rgt-cell-inner rgt-text-truncate" title={data?.description}>{data?.description}</div>
      ),
      label: "Descrição",
      width: "400px",
      cellRenderer: commonCellRenderer,
    },
    {
      id: "createdAt",
      field: "createdAt",
      cellRenderer: ({ data }) => (
        <div className="rgt-cell-inner rgt-text-truncate">
          {data?.createdAt ? moment(data?.createdAt).format("DD/MM/YYYY") : "Data de Criação"}
        </div>
      ),
      label: "Data de Inicio",
      width: "150px",
      cellRenderer: commonCellRenderer,
    },
  ]

  return (
    <div className="assistance-to-resolve__container">
      <header className='to-resolve-header__container'>
        <div className='header-filter'>
          <SelectInput
            isSearchable
            whiteVariation
            placeholder='Filtrar por tag(s)'
            isMulti
            value={searchTagValue}
            options={tagsOptions || []}
            onChange={handleSearchTagChange}
          />
        </div>
        <div className='header__content'>
          <AssistanceTagContainer
            selectedAssistance={selectedAssistance}
            setReload={setReload}
          />
        </div>
      </header>
      <div className="assistance-to-resolve-screen">
        <HeaderCard
          title={openQuestions ? "Questões" : "Registros"}
          goBack={() => (openQuestions ? goBack() : goBack(true))}
        />
        <div
          className={`${
            openQuestions ? "question-container question-container--options" : "question-container"
          }`}>
          {openQuestions ? (
            <>
              <div className="steps-questions-assistance">
                <Label label="Etapa" />
                <SelectInput
                  value={selectedStep?.value}
                  options={formSteps}
                  onChange={onStepSelect}
                />
              </div>
              <div className="questions-input" key={selectedStep?.value}>
                {loadingQuestions ? (
                  <div>
                    <LoadingWithLabel labelLoading="Buscando Questões..." colorSpinner="primary" />
                  </div>
                ) : inputData && inputData?.fields?.length ? (
                  inputData?.fields?.map((answer, index) => (
                    <div className="question-inputs" key={answer?.id}>
                      <div className="labelContainer">
                        <Label
                          className="questionTitle"
                          label={`${index + 1}. ${answer.title}`}
                          subtitle={answer.type !== "table" ? answer.info : ""}
                        />
                      </div>
                      {getInputType(
                        answer,
                        onChangeQuestionsInfo,
                        onChangeFile,
                        uploadedFiles,
                        removeFile,
                        loadingProcessImage,
                        control,
                        register,
                        values,
                      )}
                    </div>
                  ))
                ) : (
                  <div className="questions-input-empty">
                    Não há questões para responder nesta etapa
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="assistance-list__container">
              <Grid
                columns={columns()}
                rows={dataResolve}
                onSelectedRowsChange={handleSelectedAssistance}
                isLoading={loadingDataToResolve}
                onRowClick={(
                  { data: { id }, isEdit },
                  { rowSelectionApi: { getIsRowSelectable, toggleRowSelection } },
                ) => !isEdit && getIsRowSelectable(id) && toggleRowSelection(id)}
              />
            </div>
          )}
        </div>
        {openQuestions && (
          <div className="button-resolve-screen">
            <div className="tags-assistance-footer">
              <TagsCellGrid {...{ data: currentRowData, showNumber: 6 }} handleRemoveTag={handleRemoveTag}/>
            </div>
            <ButtonLoader
              color="orange"
              loading={loading}
              isDisabled={loadingProcessImage || loading}
              handleClick={handleOpenNextEvent}
              label="Salvar Atendimento"
            />
          </div>
        )}
      </div>
      {evaluationModal && 
        ModalAlert.success({
          title: "Deseja enviar uma mensagem de avaliação?",
          confirmLabel: "Enviar avaliação",
          onConfirm: () => handleSendEvaluation(),
        })
      }
      <ModalPanel modalIsOpen={afterResolveModal}>
        <ModalHeader closeModal={handleCloseNextEvent} title="Agendar próximo atendimento" />
        <ModalBody>
          <div className="scroll-select-modal question-options-modal">
            <FormRow>
              <Label label="Data para o próximo atendimento" />
              <Input
                type="date"
                min={moment().add("days", 1).format("YYYY-MM-DD")}
                onChange={(e) => handleChangeNextDate("nextDate", e.target.value)}
                defaultValue={nextDateValues?.nextDate}
              />
            </FormRow>
            <FormRow>
              <Label label="Formulários que serão criados" />
              <SelectInput
                name="forms"
                isMulti
                isSearchable
                placeholder="Formulários"
                options={formOptions}
                onChange={(value) => handleChangeNextDate("forms", value)}
                isRequired={true}
                defaultValue={nextDateValues?.forms}
              />
            </FormRow>
            <FormRow>
              <Label label="Observações" />
              <TextArea
                className="description"
                placeholder="Observações para o próximo atendimento"
                onChange={(e) => handleChangeNextDate("description", e.target?.value)}
                hasFocus={true}
              />
            </FormRow>
            <FormRow>
              <Label label="Tags do atendimento (digite para pesquisar ou criar uma nova)" />
              <SelectInputCreatable
                name="tags"
                isMulti
                isSearchable
                placeholder="Tags"
                options={tagsOptions}
                onChange={handleChangeTags}
                defaultValue={tags}
              />
            </FormRow>
            <CheckBox
              className="pending-assistance"
              label="Deixar como pendente"
              title="Selecionando, você setará este atendimento pendente podendo retornar a qualquer momento"
              onChange={handlePendingAssistance}
              value="pendingAssistance"
              checked={pendingAssistance}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonLoader
            loading={loading}
            messageProcess="Salvando"
            label="Salvar"
            color="orange"
            handleClick={saveFormSubmission}
          />
        </ModalFooter>
      </ModalPanel>
    </div>
  )
}
